import { EOfficeType, Filters } from 'shared/types/filters';

import { isSingleOfficeType } from './isSingleOfficeType';

export function isCommercialLand(filters: Filters): boolean {
  return isSingleOfficeType(filters) && filters.officeType.includes(EOfficeType.CommercialLand);
}
